import { createAction } from 'redux-actions';

export const successImportItem = createAction('INVENTORY_ITEM_SUCCESS_IMPORT');

export const failedImportItem = createAction('INVENTORY_ITEM_FAILED_IMPORT');

export const ignoredImportItem = createAction('INVENTORY_ITEM_IGNORED_IMPORT');

export const clearImportItems = createAction('INVENTORY_ITEMS_CLEAR_IMPORT');
